import { getTextContent } from 'helpers';


const ApiIntegrationList = ({ lists }) => {
    return (

        <> {getTextContent(lists)}</>

    );
}

export default ApiIntegrationList;